import PropTypes from 'prop-types';
import React from 'react';
import {
  ButtonToolbar,
  Button,
  Badge,
} from 'react-bootstrap';
import ProposalSendModal from './ProposalSendModal';
import RequestBidsModal from './RequestBidsModal';
import { fromNow } from '../../../core/date';


class ProposalSendMenu extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      brand: "Unbranded",
      activeTab:"hotel",
      activateKey:false,
      existVal:null,
    };

    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.send = this.send.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.existingValue = this.existingValue.bind(this);
  }

  close() {
    this.setState({ showModal: false });
  }
  open() {
    this.setState({ showModal: true });
    this.setBrandName()
  }
  existingValue(val){
    const value = val;
    this.setState({existVal:value})
  }
  setBrandName(){
    if ( this.props.proposal.brand.name){
      this.setState({ 
        brand: this.props.proposal.brand.name,
        activeTab : "brand",
        activateKey: true,
         });
    } else{
      this.setState({ 
        brand: "Unbranded",
        activeTab:"hotel",
        activateKey:false,
         });

    }
  }
  send() {
    this.handleSubmit({});
  }
  handleSubmit(values) {
    this.props.sendProposal(
      this.props.proposal.id,
      values,
    );
    this.close();
  }
  renderSendNow() {
    if (this.props.proposal.contacts.length > 0 && this.props.status.pending) {
      return (
        <Button id={this.props.proposal.id} bsStyle="info" onClick={this.send} >
          <i
            className="fa fa-envelope"
            aria-hidden="true"
          /> Send Now <Badge>{this.props.status.pending}</Badge>
        </Button>);
    }
    return null;
  }
  renderSentOn() {
    if (this.props.proposal.sent_on) {
      return (
        <p>Bid request sent {fromNow(this.props.proposal.sent_on)}.</p>
      );
    }
    return null;
  }
  render() {
    // No proposal send for non-branded proposals
    //if (!this.props.proposal.brand) {
    //  return null;
    //}
    const sendNow = this.renderSendNow();
    const sentOn = this.renderSentOn();
    return (
      <div>
        <ButtonToolbar>
          <Button
            id={this.props.proposal.id}
            bsStyle="info"
            onClick={this.open}
          >
            <i
              className="fa fa-plus"
              aria-hidden="true"
            /> Request Bid
          </Button>
          {sendNow}
        </ButtonToolbar>
        { (this.props.status.pending !== 0) && (
          <p><strong>{this.props.status.pending} requests need to be sent.</strong></p>
        )}
        {sentOn}
        {this.state.showModal && (
          <RequestBidsModal
            proposal={this.props.proposal}
            tourData={this.props.proposal.tour.tour_stops}
            show={this.state.showModal}
            brand = {this.state.brand}
            active = {this.state.activeTab}
            activateKey = {this.state.activateKey}
            close={this.close}
            sendProposal={this.props.sendProposal}
            status={this.props.status}
            addHotelContact={this.props.addHotelContact}
            addBrandContact={this.props.addBrandContact}
            sendHotelBidRequests={this.props.sendHotelBidRequests}
            HotelContactDelete={this.props.HotelContactDelete}
            HotelContactUpdate={this.props.HotelContactUpdate}
            HotelBrandContactUpdate={this.props.HotelBrandContactUpdate}
            HotelBrandContactDelete={this.props.HotelBrandContactDelete}
            existingValue={this.existingValue}
            existVal={this.state.existVal}
          />
        )}
      </div>
    );
  }
}


ProposalSendMenu.propTypes = {
  proposal: PropTypes.object.isRequired,
  sendProposal: PropTypes.func.isRequired,
  status: PropTypes.object.isRequired,
};

ProposalSendMenu.defaultProps = {
  proposal: {
    contacts: [],
    bids: [],
  },
};
export default ProposalSendMenu;



// WEBPACK FOOTER //
// src/routes/tours/components/ProposalSendMenu.js